import { useContext } from "react";
import { AppContext } from "@shared/context";

export default function useAppContext() {
	const ctx = useContext(AppContext);

	return ctx;
}
